import {router} from "../core/router";

export const restHelperService = {
    createGetRequest,
    createPostRequest,
    createPutRequest,
    createPatchRequest,
    createDeleteRequest,
    getResponse,
    handleCatch
};


async function createGetRequest(url, request = {}) {
    const urlObj = new URL(window.location.origin + url);
    Object.keys(request).forEach(key => {

        if (key.startsWith("multipleValueArray")) {
            request[key].values.forEach(value => {
                urlObj.searchParams.append(request[key].key, value)
            });
        } else {
            urlObj.searchParams.append(key, request[key]);
        }
    });
    return createRequest("GET", urlObj, null, true);
}

async function createPostRequest(url, request, useAuthentication = true) {
    return createRequest("POST", url, request, useAuthentication);
}

async function createPutRequest(url, request, useAuthentication = true) {
    return createRequest("PUT", url, request, useAuthentication);
}

async function createPatchRequest(url, request, useAuthentication = true) {
    return createRequest("PATCH", url, request, useAuthentication);
}

async function createDeleteRequest(url, request, useAuthentication = true) {
    return createRequest("DELETE", url, request, useAuthentication);
}

async function createRequest(method, url, request, useAuthentication) {
    let data = {
        method: method,
        headers: getHeader(useAuthentication)
    };
    if (request) {
        data.body = JSON.stringify(request);
    }
    let responseRaw = await fetch(url, data);
    try {
        let response = await responseRaw.json();
        if (response.response.authorized === false) {
            localStorage.removeItem("token");

            router.push({path: '/login'});
        }
        return validateResponse(response);
    } catch (e) {
        return Promise.reject(e);
    }
}


function getHeader(useAuthentication) {

    if (!useAuthentication) {
        return new Headers();
    } else {
        return getAuthHeader();
    }
}

function getAuthHeader() {
    let token = localStorage.getItem('token');
    if (token) {
        return {
            'token': token
        }
    }
    return new Headers();
}

function getResponse(res) {
    return res.response;
}

function validateResponse(res) {
    if (res.response.success) {
        return Promise.resolve(res);
    } else {
        return Promise.reject(res);
    }
}

function handleCatch(res) {
    return Promise.reject(res);
}
